<template>
  <div v-if="!showRequest">
    <app-history @clicked="$router.push('/morkhasi-history')" />
    <v-card class="fullForm">
      <div class="fullText">
        شما در اين بخش قادر خواهيد بود، بصورت سيستمي،‌ درخواست مرخصی خود را
        ارسال فرمائيد.
        <br />

        درخواست شما توسط واحدهاي مربوطه مركز مديريت بررسي و در صورت تاييد، مرخصی
        براي شما ثبت خواهد شد.
        <br />

        بعد از اظهار نظر نهایی ، اطلاع رساني از طريق پيامك و سامانه طلوع به شما
        صورت خواهد گرفت.
        <br />

        ضمنا شما مي توانيد در بخش مشاهده سوابق اقدام به پيگيري درخواست خود
        نمائيد.
        <br />
        <br />
      </div>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="request" rounded @click="handleShowRequest">
          درخواست مرخصی
        </v-btn>
      </v-row>
    </v-card>
  </div>
  <div v-else>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>از تاریخ:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(1)">
            {{ startSelected ? startDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تا تاریخ:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(2)">
            {{ endSelected ? endDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> نوع مرخصی </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select :items="morkhasiInfo" item-text="Text" item-value="Value" v-model="morkhasiType"></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input label="پیوست مستندات" v-model="image"></v-file-input>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn color="primary white--text" class="register" rounded @click="applyRequest" :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
        </v-btn>
      </v-row>
    </v-card>
    <date-picker ref="datepicker1" v-model="startDate" :editable="false" :auto-submit="true" element="fileInput1"
      @change="onChangeDate($event, 1)"></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker ref="datepicker2" v-model="endDate" :editable="false" :auto-submit="true" element="fileInput2"
      :min="startDate" @change="onChangeDate($event, 2)"></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import { requestMorkhasi } from "@/api/morkhasi";
import { TODAY } from "@/utils/constants";
import HistoryButton from "@/components/HistoryButton";
import moment from "moment-jalaali";
export default {
  data() {
    return {
      today: TODAY,
      showRequest: false,
      startDate: TODAY,
      endDate: TODAY,
      startSelected: false,
      endSelected: false,

      image: null,
      morkhasiType: "",
      comment: "",
    };
  },
  components: {
    appHistory: HistoryButton,
  },
  methods: {
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.startDate = date;
        this.startSelected = true;
      } else {
        this.endDate = date;
        this.endSelected = true;
      }
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";
      if (!this.startSelected) {
        text = "لطفا زمان شروع را انتخاب کنید.";
      } else if (!this.endSelected) {
        text = "لطفا زمان پایان را انتخاب کنید.";
      } else if (this.startDate > this.endDate) {
        text = "زمان شروع بایستی پیش از زمان پایان باشد.";
      } else if (this.morkhasiType == "") {
        text = "نوع مرخصی انتخاب نشده است.";
      } else if (this.morkhasiType == "14" && this.image == null) {
        text = "جهت مرخصی بدون احتساب سنوات، پیوست مستندات ضروری می باشد.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        requestMorkhasi(
          this.image,
          this.startDate,
          this.endDate,
          this.morkhasiType,
          this.comment
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.goToIndex();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    goToIndex() {
      this.$router.push({ path: "/index" });
    },
    handleShowRequest() {
      window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showRequest: "true"
        }
      });

    }
  },
  /**
   * get khorooji meta data
   */
  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getMorkhasiInfo");
  },
  computed: {
    morkhasiInfo() {
      return this.$store.getters.morkhasiInfo;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  watch: {

    '$route'(to, from) {
      this.showRequest = !!this.$route.query.showRequest;
      window.scrollTo(0, 0)
    }
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.v-simple-checkbox {
  padding: 2px 10px 0 0;
  float: left;
}




.request {
  width: 300px !important;
  margin: 15px;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
